;(function () {
    'use strict';
    ready(function() {
        window.NSW.initSite();
    });
}());
